import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { Formik } from 'formik';
/* import { withFirebase } from '../../components/Firebase/index';
 */import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import SignUpForm from './components/SignUpForm';
import FullScreenLoader from '../../components/FullScreenLoader';
import EmailVerificationModal from '../../components/Modal/EmailModal';
import { addFormValues } from '../../store/modules/formValues';
import {
  assertionStepSubmittedAction,
  stepsSubmittedResetAction
} from '../../store/modules/assertionStepsSubmitted';
import { validationContactInfo } from '../../utils/validations';
import { SIGNIN } from '../../routes';
import { signUpUser } from '../../store/actions/UserAction'
import {getCurrentUser ,auths , doSignOut}  from '../../configs/environments/firebase/firebaseApp'
import axios from 'axios';


class SignUp extends Component {
  state = {
    formValues: {
      email: '',
      password: '',
      phone: '',
      specialties:'',
      professionalID: '',
      termsAndConditions: false
    },
    wasSignUpSuccessfully: false,
    isInitialValid: false,
    redirect: false,
    loading: false,
    loadingFormData: true,
    error: null,
    userProfile:{}
  };

  

  componentDidMount() {
    const { isSecondStepSubmitted, isThirdStepSubmitted } = this.props;
    if (isSecondStepSubmitted) {
      if (isThirdStepSubmitted) {
        this.setPrevFormValues();
        this.setState({ loadingFormData: false });
      } else {
        this.setState({ loadingFormData: false });
      }
    } else {
      this.setState({ loadingFormData: false, redirect: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.formValues !== this.props.formValues) {
      this.setPrevFormValues();
    }
  }

  setPrevFormValues = () => {
    this.setState(prevState => ({
      formValues: {
        ...prevState.formValues,
        ...this.props.formValues
      },
      isInitialValid: true
    }));
  };



  handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    try {
      setSubmitting(false);
      this.setState({ loading: true });
      const {
        submitFormValues,
        submitStep,
        stepsSubmitted,
        isLawyer,
        signUpUser
      } = this.props;
      await submitFormValues(values);
      await submitStep({
        ...stepsSubmitted,
        signUp: true
      });
      const {
        formValues: { officeName, email, password, ...rest }
      } = this.props;
      let profile = isLawyer
        ? { role: 'lawyer', ...rest , email}
        : { role: 'lawFirm', officeName, ...rest , email};
      this.setState({userProfile : profile})
      signUpUser(email, password, profile )
        .then(res=>{
           
           var data = JSON.stringify({"email": email });
          var config = {
            method: 'post',
            url: 'https://us-central1-contacta-abogado.cloudfunctions.net/contactaBackend/verify_email/account_activation',
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
          };
          let response = axios(config)
          .then(function (response) {
            console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
          }); 
          let roleUser = isLawyer ? 'lawyer' :'lawFirm';


          var config2 = {
            method: 'post',
            url: `https://us-central1-contacta-abogado.cloudfunctions.net/contactaBackend/paging/update_total_users?role=${roleUser}`,
            headers: { }
          };
          axios(config2)
          .then(function (response) {
            console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
          });


          this.setState({ wasSignUpSuccessfully: true }); 
        })
      .catch(error =>{
        if (error && error.code === 'auth/email-already-in-use') {
        this.setState({ loading: false }, () =>
          setFieldError(
            'email',
            'La dirección de correo electrónico ya existe.'
          )
        );
      } else {
        this.setState({ error, loading: false });
      } 
    })
  }catch (error){}
  }

  createNewUser = ({ email, password, profile }) => {
    return new Promise((resolve, reject) => {
      const { createUser } = this.props.firebase;
      createUser({ email, password }, profile)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  };

  handleResetFormValues = () => {
    const { submitFormValues, stepsSubmittedReset, history } = this.props;
    let formValues = {
      name: '',
      firstLastName: '',
      secondLastName: '',
      specialties: '',
      email: '',
      password: '',
      phone: '',
      professionalID: '',
      termsAndConditions: false
    };
    submitFormValues(formValues).then(() => {
      doSignOut().then(res=>{
        stepsSubmittedReset();
        history.push(SIGNIN);
      })
      
    });
  };

  handleClose = () => {
    this.setState({ loading: false });
  };

  render(props) {
    const {
      redirect,
      loading,
      loadingFormData,
      error,
      formValues,
      isInitialValid,
      wasSignUpSuccessfully
    } = this.state;
    const { profile, authError, isLawyer } = this.props;
   
    if (loadingFormData) {
      return (
        <div className="flexContainer--center">
          <CircularProgress color="secondary" />
        </div>
      );
    }

    if (redirect) {
      return <Redirect to="/registro-abogados" />;
    }

    return (
      <>
        <FullScreenLoader loading={loading} />

        {error && authError && (
          <Typography align="center" color="error">
            {authError.message}
          </Typography>
        )}

        <Formik
          initialValues={formValues}
          isInitialValid={isInitialValid}
          validationSchema={validationContactInfo}
          onSubmit={this.handleSubmit}
          render={props => <SignUpForm isLawyer={isLawyer} {...props} />}
        />

        {wasSignUpSuccessfully && (
          <EmailVerificationModal
            noticeText="SE ENVIÓ UN CORREO PARA VERIFICAR TU CUENTA"
            email={this.state.userProfile && this.state.userProfile.email && this.state.userProfile.email}
            handleClick={this.handleResetFormValues}
          />
        )}
      </>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  submitFormValues: formValues => dispatch(addFormValues(formValues)),
  submitStep: steps => dispatch(assertionStepSubmittedAction(steps)),
  stepsSubmittedReset: () => dispatch(stepsSubmittedResetAction),
  signUpUser: (email, password, profile) => dispatch(signUpUser(email, password, profile))
})

const mapStateToProps = ({
  formValues,
  stepsSubmitted,
/*   firebase: { auth, authError, profile }
 */}) => ({
 /*  auth,
  authError,
  profile, */
  formValues,
  isLawyer: stepsSubmitted.accountType === 'lawyer',
  isSecondStepSubmitted: stepsSubmitted.personalInformation,
  isThirdStepSubmitted: stepsSubmitted.signUp
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp)